import { entityBaseBodyRender } from '@app/components/common/table';
import { TableColumn } from '@app/components/common/table/types';

export const Columns: TableColumn[] = [
  {
    name: 'id',
    label: '#',
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: 'name',
    label: 'Название',
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: 'inn',
    label: 'ИНН',
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: 'channel',
    label: 'Канал',
    options: {
      filter: false,
      sort: true,
      customBodyRender: entityBaseBodyRender(true),
    },
  },
  {
    name: 'sub_channel',
    label: 'Подканал',
    options: {
      filter: false,
      sort: true,
      customBodyRender: entityBaseBodyRender(true),
    },
  },
  {
    name: 'region',
    label: 'Регион',
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: 'city',
    label: 'Город',
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: 'rm',
    label: 'РМ',
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: 'tm',
    label: 'ТМ',
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: 'status',
    label: 'Статус',
    options: {
      filter: {
        name: 'status_id',
        label: 'Статус',
        sourceName: 'distributor_status',
        type: 'multi-select'
      },
      sort: true,
    },
  },
];
